const STUDENT_CERT_TYPES = {
  FETCH_STUDENTS_REQUEST: 'STUDENT_CERT/FETCH_STUDENTS_REQUEST',
  FETCH_STUDENTS_SUCCESS: 'STUDENT_CERT/FETCH_STUDENTS_SUCCESS',
  FETCH_STUDENTS_FAILURE: 'STUDENT_CERT/FETCH_STUDENTS_FAILURE',

  FETCH_STUDENT_DETAIL_REQUEST: 'STUDENT_CERT/FETCH_STUDENT_DETAIL_REQUEST',
  FETCH_STUDENT_DETAIL_SUCCESS: 'STUDENT_CERT/FETCH_STUDENT_DETAIL_SUCCESS',
  FETCH_STUDENT_DETAIL_FAILURE: 'STUDENT_CERT/FETCH_STUDENT_DETAIL_FAILURE',
  CLEAR_STUDENT_DETAIL: 'STUDENT_CERT/CLEAR_STUDENT_DETAIL',

  SET_FILTERS: 'STUDENT_CERT/SET_FILTERS',
  RESET_FILTERS: 'STUDENT_CERT/RESET_FILTERS',
};

export default STUDENT_CERT_TYPES;
